import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualTaxinvoicePage } from './manual-taxinvoice.page';

const routes: Routes = [
  {
    path: '',
    component: ManualTaxinvoicePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualTaxinvoicePageRoutingModule {}
